import { useLoginModalStore } from '@/stores/loginModal';
/**
 * 打开登录弹窗，不记录入口点击。
 */ export function openLoginModal(options) {
    useLoginModalStore.getState().open(options);
}
/**
 * 游客点击登录入口后打开登录弹窗。
 */ export function openGuestLoginModal(location, options) {
    collect('guest_login_click', {
        location
    });
    openLoginModal(options);
}
